<div class="page-wrapper">
<app-header *ngIf="showHeader"></app-header>
<router-outlet></router-outlet>

<app-footer *ngIf="showFooter"></app-footer>
</div>
<div class="backspinner" *ngIf="mode === 'indeterminate'">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
</div>